// Action creators extracted from PlatformModule.js

import React from "react";
import {
  SET_ORGANIZATION_CURRICULUM_PROGRAMS,
  SET_ORGANIZATION_PLANNER_ELEMENT_SETS,
  SET_ORGANIZATION_PLANNER_ELEMENT_SET_LABELS,
  SET_CURRENT_CURRICULUM_PROGRAM,
  SET_CURRENT_PLANNER_ELEMENT_SETS,
  SET_ACADEMIC_YEAR_SELECTED,
  SET_ACADEMIC_YEAR_SELECTED_FOR_CURRENT_CURRICULUM_PROGRAM,
  SET_SAMPLE_ORG_PORTAL_TYPE,
  SET_DEMO_ORG_CURRICULUM_ID,
  SET_ORGANIZATION_SUBJECT_LEVEL_TAGS,
  SET_DEFAULT_NAME_SORT_PREFERENCE,
  SET_DEFAULT_STUDENT_NAME_ORDER_PREFERENCE,
  SET_DEFAULT_STUDENT_IDENTIFICATION_NAME_PREFERENCE,
  SET_FULLSCREEN_LOADING,
  SET_UBD_ASSESSMENT_TYPES,
  SET_AI_MODULE_MARKETING_KEY,
  SET_ACTIVE_THIRDPANE_NOTIFICATION_TAB,
  HOME_PAGE_WIDGET_PREFERENCES,
  SET_TODDLE_LIBRARY_VISIBILITY,
  SET_ACADEMIC_TYPE_CURRICULUM_PROGRAMS,
  SET_ACCOUNT_TYPE_CURRICULUM_PROGRAMS,
  SET_SCHOOL_TYPE_CURRICULUM_PROGRAMS,
  SET_LEARNING_COURSE_ENABLED,
  CONTEXTUAL_HELP_SIDEBAR_TOGGLE,
  SET_CONTEXTUAL_HELP_SEARCH_TEXT,
  SET_CURRICULUM_SUBJECT_LEVEL_TAGS,
  SET_CONTEXTUAL_HELP_SELECTED_OPTION,
  SET_CUSTOM_ICONS,
  ADD_PROCESSED_CUSTOM_ICON,
  RESET_CONTEXTUAL_HELP_SELECTED_OPTION,
} from "./PlatformConstants";

// Action Creators
export const setOrganizationCurriculumPrograms = data => {
  return {
    type: SET_ORGANIZATION_CURRICULUM_PROGRAMS,
    data,
  };
};

export const setHomePageWidgetPreference = data => {
  return {
    type: HOME_PAGE_WIDGET_PREFERENCES,
    data,
  };
};

export const setThirdPaneNotificationCenterActiveTab = data => {
  return {
    type: SET_ACTIVE_THIRDPANE_NOTIFICATION_TAB,
    data,
  };
};

/**
 * @deprecated since version 0.0. Will be deleted in version 0.0
 * Use setCurrentPlannerElementSets instead.
 */
export const setOrganizationPlannerElementSets = data => {
  return {
    type: SET_ORGANIZATION_PLANNER_ELEMENT_SETS,
    data,
  };
};

/**
 * @deprecated since version 0.0. Will be deleted in version 0.0
 * Use setCurrentPlannerElementSets instead.
 */
export const setOrganizationPlannerElementSetLabels = data => {
  return {
    type: SET_ORGANIZATION_PLANNER_ELEMENT_SET_LABELS,
    data,
  };
};

export const setCurrentCurriculumProgram = data => {
  return {
    type: SET_CURRENT_CURRICULUM_PROGRAM,
    data,
  };
};

export const setCurrentPlannerElementSets = data => {
  return {
    type: SET_CURRENT_PLANNER_ELEMENT_SETS,
    data,
  };
};

export const setAcademicYearSelected = data => {
  return {
    type: SET_ACADEMIC_YEAR_SELECTED,
    data,
  };
};

export const setAcademicYearSelectedForCurrentCurriculumProgram = data => {
  return {
    type: SET_ACADEMIC_YEAR_SELECTED_FOR_CURRENT_CURRICULUM_PROGRAM,
    data,
  };
};

export const setSampleOrgPortalType = data => {
  return {
    type: SET_SAMPLE_ORG_PORTAL_TYPE,
    data,
  };
};

export const setDemoOrgCurriculumId = data => {
  return {
    type: SET_DEMO_ORG_CURRICULUM_ID,
    data,
  };
};

export const setOrganizationSubjectLevels = data => {
  return {
    type: SET_ORGANIZATION_SUBJECT_LEVEL_TAGS,
    data,
  };
};

export const setCurriculumSubjectLevels = data => {
  return {
    type: SET_CURRICULUM_SUBJECT_LEVEL_TAGS,
    data,
  };
};

export const setDefaultNameSortPreference = data => {
  return {
    type: SET_DEFAULT_NAME_SORT_PREFERENCE,
    data,
  };
};

export const setDefaultStudentNameOrderPreference = data => {
  return {
    type: SET_DEFAULT_STUDENT_NAME_ORDER_PREFERENCE,
    data,
  };
};

export const setDefaultStudentIdentifierNamePreference = data => {
  return {
    type: SET_DEFAULT_STUDENT_IDENTIFICATION_NAME_PREFERENCE,
    data,
  };
};

export const setFullScreenLoading = data => {
  return {
    type: SET_FULLSCREEN_LOADING,
    data,
  };
};

export const setUbdAssessmentTypes = data => {
  return {
    type: SET_UBD_ASSESSMENT_TYPES,
    data,
  };
};

export const setAiModuleMarketingKey = data => {
  return {
    type: SET_AI_MODULE_MARKETING_KEY,
    data,
  };
};

export const setToddleLibraryVisibility = data => {
  return {
    type: SET_TODDLE_LIBRARY_VISIBILITY,
    data,
  };
};

export const setAccountTypeCurriculumPrograms = data => {
  return {
    type: SET_ACCOUNT_TYPE_CURRICULUM_PROGRAMS,
    data,
  };
};

export const setAcademicTypeCurriculumPrograms = data => {
  return {
    type: SET_ACADEMIC_TYPE_CURRICULUM_PROGRAMS,
    data,
  };
};

export const setSchoolTypeCurriculumPrograms = data => {
  return {
    type: SET_SCHOOL_TYPE_CURRICULUM_PROGRAMS,
    data,
  };
};

export const setLearningCourseEnabled = data => {
  return {
    type: SET_LEARNING_COURSE_ENABLED,
    data,
  };
};

export const setCustomIcons = icons => {
  return {
    type: SET_CUSTOM_ICONS,
    data: icons,
  };
};

export const addProcessedCustomIcon = icon => {
  return {
    type: ADD_PROCESSED_CUSTOM_ICON,
    data: icon,
  };
};

export const setContextualHelpSearchText = text => {
  return {
    type: SET_CONTEXTUAL_HELP_SEARCH_TEXT,
    data: text,
  };
};

export const setContextualHelpSelectedOption = data => {
  return {
    type: SET_CONTEXTUAL_HELP_SELECTED_OPTION,
    data: data,
  };
};

export const resetContextualHelpSelectedOption = data => {
  return {
    type: RESET_CONTEXTUAL_HELP_SELECTED_OPTION,
    data: data,
  };
};

export const setContextualHelpSidebarVisible = data => {
  return {
    type: CONTEXTUAL_HELP_SIDEBAR_TOGGLE,
    data,
  };
};
